export const pageTransitionDuration = 0.8
